import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["progress"]

  connect() {
    this._onAnimationEnd = () => this.reset()
    this.progressTarget.addEventListener("animationend", this._onAnimationEnd)
    this.progressTarget.classList.add("animating")
  }

  disconnect() {
    this.progressTarget.removeEventListener("animationend", this._onAnimationEnd)
  }

  reset() {
    window.Turbo.visit("/")
  }
}
